







import { Vue, Component, State } from "nuxt-property-decorator";
import NavPureLogoHeader from "~~/components/header/nav-pure-logo-header";
import { countryLangMap } from "~/const/locale";

@Component({
  name: "unsubscriptionLayout",
  components: {
    "nav-pure-logo-header": NavPureLogoHeader,
  },
})
export default class App extends Vue {
  @State((state) => state.lang) lang: string;

  created() {
    if (!process.server) {
      this.$commonReport(this.$TeaMap.landing_page_visit);
    }
  }

  head() {
    return {
      htmlAttrs: {
        lang: this.lang,
        dir: this.lang === countryLangMap.AR ? "rtl" : "ltr",
      },
    };
  }
}
